module.exports = __webpack_public_path__ + "img/my-comission-blue.1e007e6a.svg";